import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const ImageZoomMobile = ({ url, showMask = false, maskUrl = null, onCloseModal, children }) => {
  return (
    <div className={styles.imageBoxZoomMobile}>
      <TransformWrapper initialScale={0.4} minScale={0.2} initialPositionX={0} initialPositionY={200}>
        {({ zoomIn, zoomOut }) => (
          <>
            <div className={styles.imageBoxZoomMobileNav}>
              <Button type="primary" icon={<CroplerIcon name="add" />} onClick={() => zoomIn()} />
              <Button type="primary" icon={<CroplerIcon name="minus" />} onClick={() => zoomOut()} />
            </div>
            <TransformComponent>
              <div className={styles.imageBoxZoomMobileImageWrapper}>
                <img className={styles.imageBoxZoomMobileImg} src={url} alt="Cropler" />
                {showMask && maskUrl && <img className={styles.imageBoxZoomMobileMask} src={maskUrl} alt="" />}
              </div>
            </TransformComponent>
          </>
        )}
      </TransformWrapper>
      <Button
        className={styles.imageBoxZoomMobileClose}
        type="primary"
        icon={<CroplerIcon name="close" />}
        onClick={onCloseModal}
      />
      {children}
    </div>
  )
}

export default ImageZoomMobile